import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Ajax from './service'
import 'babel-polyfill'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueParticles from 'vue-particles'
import 'iview/dist/styles/iview.css'
import './assets/styles/layout.scss'
import iView from 'iview';
Vue.use(iView)

Vue.config.productionTip = false
Vue.prototype.Ajax = Ajax
// 全局注册swiper
Vue.use(VueAwesomeSwiper)
// 注册粒子效果
Vue.use(VueParticles)
// 注册全局过滤器
Vue.filter('formatCreateTime', (val) => {
  return val.split(' ')[0]
})

// 修复iview 在IE10及以下版本不支持dataset属性的问题，兼容transfer-dom.js中使用了dataset的问题
let isIE = () => {
  return(window.navigator.userAgent.indexOf("MSIE") >= 1)
}
if(isIE() && window.HTMLElement) {
  if(Object.getOwnPropertyNames(HTMLElement.prototype).indexOf('dataset') === -1) {
    Object.defineProperty(HTMLElement.prototype, 'dataset', {
      get: function() {
        let attributes = this.attributes;
        let name = []
        let value = []
        let obj = {}
        for(var i = 0; i < attributes.length; i++) {
          if(attributes[i].nodeName.slice(0, 5) == 'data-') {
            name.push(attributes[i].nodeName.slice(5))
            value.push(attributes[i].nodeValue)
          }
        }
        for(var j = 0; j < name.length; j++) {
          obj[name[j]] = value[j]
        }
        return obj
      }
    })
  }
}


router.beforeEach((to, from, next) => {
  let nodes = document.querySelectorAll('.daq-header-down')
  for (let i = 0; i < nodes.length; i++) {
    nodes[i].style.height = 0
  }
  if (to.meta.title) {
    document.title = to.meta.title
  }
  document.body.scrollTop = 0
  document.documentElement.scrollTop = 0
  next()
})

router.afterEach(() => {
  let nodes = document.querySelectorAll('.daq-header-down')
  for (let i = 0; i < nodes.length; i++) {
    setTimeout(() => {
      nodes[i].removeAttribute('style')
    }, 100);
  }
})

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
